<template>
    <div class="content-box td-fcc td-fc">
        <div class="top-title td-fcc">
            <img :src="GLOBAL.Images.icon_edit_text" alt="">
            <span>{{dataSource.edition}}</span>
            <span>（题量：{{dataSource.count}}）</span>
        </div>
        <!--结果部分-->
        <transition name="el-fade-in" mode="out-in">
            <div class="result-box td-fc td-fcc">
                <div class="result-info-1">
                    <div>答对：{{dataSource.complete}} 题</div>
                    <div>答错：{{dataSource.un_complete}} 题</div>
                    <div>用时：{{dataSource.use_time}}</div>
                </div>
                <div class="result-info-2">
                    您已掌握本学学段单词量 <span>{{dataSource.complete_rate}}%</span>
                </div>
                <div class="result-info-2">
                    您还有<span>{{dataSource.uncomplete_rate}}%</span>没有掌握哦，继续加油呢!
                </div>
                <div class="result-info-2">
                    获得<span>{{dataSource.power}}</span>能量石，全国排名<span>{{dataSource.level}}</span>!
                </div>
                <div class="hint-box">
                    <div class="td-fcc">
                        <div>
                            <img v-if="dataSource.is_pass" :src="GLOBAL.Images.icon_good">
                        </div>
                        <div>Pass</div>
                    </div>
                    <div class="td-fcc">
                        <div>
                            <img v-if="!dataSource.is_pass" :src="GLOBAL.Images.icon_good">
                        </div>
                        <div>Fail</div>
                    </div>
                </div>
            </div>
        </transition>
        <div class="push-btn">
            <el-button type="success" @click="toReport">学习报告</el-button>
            <div style="width: 80px"></div>
            <el-button type="danger" @click="close">退出测试</el-button>
        </div>
    </div>
</template>

<script>
    import report from "./report";

    export default {
        name: "resultBoard",
        props: {
            dataSource: {}
        },
        data() {
            return {};
        },
        methods: {
            toReport() {
                if (this.disabledClick) {
                    return null
                }
                this.disabledClick = true
                this.DialogResult({
                    title: '单词量测试',
                    component: report,
                    data: {
                        source: this.dataSource
                    }
                })
                this.close()
            },
            // 关闭弹窗
            close() {
                this.$parent.close();
                this.disabledClick = false
            }
        },
        created() {
        }
    };
</script>

<style scoped lang='less'>
    .content-box {
        transition: all 0.5s;
        position: relative;
        height: 100%;

        .top-title {
            font-size: 18px;
            margin-bottom: 20px;

            img {
                width: 26px;
                height: 26px;
                margin-right: 10px;
            }
        }

        .result-box {
            .result-info-1 {
                display: flex;
                justify-content: center;
                margin-bottom: 20px;
                font-size: 23px;

                > div {
                    margin: 0 15px;
                }
            }

            .result-info-2 {
                font-size: 28px;
                margin-bottom: 6px;
                color: #47c149;

                span {
                    color: #e90205;
                    font-size: 30px;
                    padding: 0 10px;
                }
            }

            .hint-box {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 10px;

                > div {
                    display: flex;
                    margin: 6px 0;

                    > div:nth-of-type(1) {
                        width: 40px;
                        height: 40px;
                        background: #fff;
                        border: 2px solid #00598d;
                        margin-right: 20px;
                        position: relative;

                        img {
                            width: 50px;
                            display: block;
                            position: absolute;
                            bottom: 0;
                            left: 0;
                        }
                    }

                    > div:nth-of-type(2) {
                        font-size: 36px;
                        font-weight: bold;
                        color: #47c149;
                        width: 100px;
                    }
                }

                > div:nth-of-type(2) {
                    > div:nth-of-type(2) {
                        color: #ff5100;
                    }
                }
            }

            .pop-btn {
                margin: 20px 0;
            }
        }

        .push-btn {
            display: flex;
            justify-content: center;
            margin-top: 30px;
        }
    }

    .user-box {
        border: none !important;
        overflow-y: auto !important;
        display: flex;
        flex-direction: column;
        padding: 0 115px;

        .info-title {
            display: flex;
            font-size: 22px;

            img {
                width: 30px;
                margin-right: 10px;
            }
        }

        .user-info {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px solid #dcdcdc;
            margin-bottom: 10px;

            .img-box {
                width: 100px;
                height: 100px;
                border-radius: 50%;
                margin-right: 35px;
            }

            .right-info {
                > div {
                    margin: 10px 0;
                }

                .name {
                    font-size: 30px;
                }
            }
        }

        .info-list {
            border-bottom: 1px solid #dcdcdc;

            > div {
                display: flex;
                font-size: 19px;
                margin: 13px 0;
                padding: 0 20px;

                > div:nth-of-type(1) {
                    width: 240px;
                }
            }
        }

        .test-explain {
            border: 1px solid #e3e3e3;
            padding: 15px 10px;
            margin-top: 10px;

            .title {
                color: #2bc3b9;
                border-left: 3px solid #2bc3b9;
                padding-left: 5px;
            }

            p {
                font-size: 16px;
                margin-top: 10px;
            }

            .guid-btn {
                text-align: right;
            }
        }

        .foot-btn {
            margin: 20px 0;
            text-align: center;
        }
    }

    .btn1,
    .btn2 {
        position: absolute;
        top: 1.25rem;
        right: 0;
        padding: 0;
        border: none;
        outline: 0;
        background: 0 0;
        font-size: 1.33333rem;
        cursor: pointer;

        img {
            width: 38px;
            height: 38px;
        }
    }

    .btn2 {
        right: 50px !important;
    }
</style>